import { Goal, ID, Task } from '@griply/types';

import { taskGoalIds } from './links/task-link-ids';

const isTaskScheduled = (task: Task): boolean =>
  !!(
    task.schedules?.length ||
    task.endStrategy?.deadline ||
    task.deadlineDeadline
  );

// Dropping a completed goal's unscheduled tasks removes its group header from the list.
export const dropTasksOfCompletedGoalsWithoutScheduledTasks = (
  tasks: Task[],
  goals: Goal[],
): Task[] => {
  const completedGoalIds = new Set(
    goals.reduce<ID[]>((acc, { id, completedAt }) => {
      if (completedAt) {
        acc.push(id);
      }
      return acc;
    }, []),
  );

  if (!completedGoalIds.size) {
    return tasks;
  }

  const completedGoalsWithScheduledTask = new Set<ID>();
  tasks.forEach((task) => {
    if (!isTaskScheduled(task)) {
      return;
    }
    taskGoalIds(task).forEach((goalId) => {
      if (completedGoalIds.has(goalId)) {
        completedGoalsWithScheduledTask.add(goalId);
      }
    });
  });

  return tasks.filter((task) => {
    const goalIds = taskGoalIds(task);
    const completedLinks = goalIds.filter((goalId) =>
      completedGoalIds.has(goalId),
    );

    // A link to a live goal keeps the task; only an all-completed task can drop out.
    if (!completedLinks.length || completedLinks.length < goalIds.length) {
      return true;
    }

    return completedLinks.some((goalId) =>
      completedGoalsWithScheduledTask.has(goalId),
    );
  });
};
